module.exports = __webpack_public_path__ + "static/img/food-img-4.5b83adb.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/food-img-4.png
// module id = VTbj
// module chunks = 1